import React, { Suspense } from 'react';
import { useParams } from 'react-router';
import { useMobile } from 'utils/media';
import bem from 'utils/bem';
import Text from 'components/Text';
import { FixedSpecialistTeaser } from 'components/SpecialistTeaser';
import Page from '../Page';
import Model from '../../../model';
import Icon from 'components/Icon';
import Address from './Address';
import Educations from './Educations';
import YouTubeTeaser from 'components/YouTubeTeaser';
import Memberships from './Memberships';
import MobileFixedSpecialistTeaser from 'components/SpecialistTeaser/FixedSpecialistTeaser/MobileFixedSpecialistTeaser';
import { Skeleton } from '@mui/material';
import { FixedSpecialistTeaserSkeleton } from 'components/SpecialistTeaser/FixedSpecialistTeaser';
import { times } from 'utils/render';
import './index.sass';
import SpecialistOrderFormModal from 'forms/forms/SpecialistOrderForm/Modal';
import { Quote } from 'components/Quote';

const { block, el } = bem('specialist');
const SpecialistContent = ({resource}) => {
    const { isMobile } = useMobile();

    const specialist = resource.read();
    const { city, experience, name, data: { specialisation, video, quote }, hasMemberships, description, hasEducations, hasAddress, addresses, memberships, educations } = specialist;

    return (
        <Layout
            isMobile={isMobile}
            SpecialistTeaserBlock={SpecialistTeaserBlock({isMobile, specialist})}
            TopBlock={TopBlock({experience, city, name, specialisation})}
            BottomBlock={BottomBlock({description, hasMemberships, memberships, quote, video, educations, hasEducations, hasAddress, addresses})}
        />
    )
}

const Layout = ({ isMobile, SpecialistTeaserBlock, TopBlock, BottomBlock }) => {
    return (
        <>
            <div className={ el('left-sidebar')}>
                { SpecialistTeaserBlock }
            </div>
            <div className={ el('content') }>
                { !isMobile && TopBlock }
                { BottomBlock }
            </div>
        </>
    )
}

const SpecialistTeaserBlock = ({ isMobile, specialist}) => isMobile ? <MobileFixedSpecialistTeaser specialist={specialist} /> : <FixedSpecialistTeaser specialist={specialist}/>

const TopBlock = ({experience, city, name, specialisation}) => (
    <>
        <div className={el('top-block')}>
            <div className={ el('caption')}>
                <div className={el('experience')}>
                    <Icon name={'crown-simple'} />
                    <Text>{ experience }</Text>
                </div>
                { city && <div className={el('location')}>
                    <Icon name={'navigation-arrow'} />
                    <Text>{city}</Text>
                </div> }
            </div>
            <div className={el('title')}>
                <Text serif>{name}</Text>
            </div>
            <div className={el('speciality')}>
                <Text>{specialisation}</Text>
            </div>
        </div>
    </>
)


const BottomBlock = ({ description, hasMemberships, memberships, quote, video, hasEducations, educations, hasAddress, addresses }) => (
    <>
        {hasMemberships && <Memberships memberships={memberships}/>}
        <Quote>{quote}</Quote>
        <div className={el('description')}>
            <div className={el('description-title')}>
                <Text tag='div' serif>{description.title}</Text>
            </div>
            <div className={el('description-list')}>
                {description.list.map((item, index) => <div className={el('description-list-item')} key={index}>
                    <Icon name={'check-circle'} />
                    <Text>{item}</Text>
                </div>)}
            </div>
        </div>
        {video && <YouTubeTeaser link={video} />}
        {hasEducations && <Educations educations={educations} /> }
        {hasAddress &&
            <div className={el('addresses')}>
                <div className={el('addresses-title')}>
                    <Text serif>Кабинет:</Text>
                </div>
                <div className={el('addresses-list')}>
                    {addresses.filter(a => a.isActive).map(Address)}
                </div>
            </div>
        }
    </>
)

const Specialist = () => {
    const { name: slug } = useParams();
    const { oneSpecialistData } = Model.specialist;

    const resource = oneSpecialistData(slug)

    return (
        <Page className={ block() } >
            <Suspense fallback={<SpecialistSkeleton />}>
                <SpecialistContent resource={resource} key={slug}/>
            </Suspense>
            <SpecialistOrderFormModal />
        </Page>
    )
}

const SpecialistSkeleton = () => {
    const { isMobile } = useMobile();

    const SpecialistTeaserBlock = <FixedSpecialistTeaserSkeleton />
    const TopBlock =  <div className={el('top-block')}>
        <div className={ el('caption')}>
            <div className={el('experience')}>
                <Text><Skeleton style={{minWidth: '70px'}} /></Text>
            </div>
            <div className={el('location')}>
                <Text><Skeleton style={{minWidth: '100px'}} /></Text>
            </div>
        </div>
        <div className={el('title')}>
            <Text serif><Skeleton width={500} style={{minWidth: '500px'}}/></Text>
        </div>
        <div className={el('speciality')}>
            <Text><Skeleton width={300} style={{minWidth: '300px'}}/></Text>
        </div>
    </div>
    const BottomBlock = <div style={{width: '100%'}}>
        { times((key) => <Skeleton key={key} style={{marginBottom: '3px', fontSize: '10px', lineHeight: '12px'}} width={`${70 + Math.random() * 30}%`}/>, 12 ) }
    </div>
    return (
        <Layout
            isMobile={isMobile}
            SpecialistTeaserBlock={SpecialistTeaserBlock}
            TopBlock={TopBlock}
            BottomBlock={BottomBlock}
        />
    )
}

export default Specialist;
